import { z } from 'zod';

/**
 * Order note content validation schema
 * - Must be between 1 and 4000 characters
 */
const noteContentSchema = z
    .string()
    .min(1, 'Note content is required')
    .max(4000, 'Note content cannot exceed 4000 characters');
/**
 * Create order note body schema (for POST /:orderId/timeline/notes)
 */
const createOrderNoteBodySchema = z.object({
    noteContent: noteContentSchema,
    sendToCommChannels: z.boolean(),
    sendToBuyer: z.boolean(),
});
/**
 * Create order note form schema for react-hook-form with zodResolver
 * Use with: resolver: zodResolver(createOrderNoteFormSchema)
 */
const createOrderNoteFormSchema = z.object({
    noteContent: noteContentSchema,
    sendToCommChannels: z.boolean(),
    sendToBuyer: z.boolean(),
});

export { createOrderNoteBodySchema, createOrderNoteFormSchema, noteContentSchema };
//# sourceMappingURL=noteValidation.js.map
